import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ConfirmOtpComponent } from './confirm-otp/confirm-otp.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent implements OnInit {

  heading: string;
  content: any;
  formFields;

  withdrawForm = new UntypedFormGroup({
    comments: new UntypedFormControl('', Validators.required),
    confirm_password: new UntypedFormControl('', Validators.required)
  })

  users = [
    {value:'1',label:'Venkat'},
    {value:'2',label:'Gopi'},
    {value:'3',label:'Siva'},
    {value:'4',label:'Upendra'},
  ] 

  constructor(public modalRef: NgbActiveModal, private modalService: NgbModal) {
  }


  ngOnInit() {
  }

  confirmWithdraw(){
    this.modalRef.dismiss();
    this.modalService.open(ConfirmOtpComponent);
  }

}
